import { useCallback, useEffect } from 'react';

import { useWorkspaceSidebarPushStore } from '~/components/v2/store/features/workspace/useWorkspaceSidebarPushStore';

export const WORKSPACE_SIDEBAR_HEADER_DROPDOWN_TOKEN = 'workspace-sidebar-header-dropdown';

export const useWorkspaceSidebarHoverSuppression = ({ token }: { token: string }) => {
  const suppressHoverOpen = useWorkspaceSidebarPushStore((s) => s.suppressHoverOpen);
  const unsuppressHoverOpen = useWorkspaceSidebarPushStore((s) => s.unsuppressHoverOpen);

  useEffect(() => () => unsuppressHoverOpen(token), [token, unsuppressHoverOpen]);

  const handleMenuOpenChange = useCallback(
    (open: boolean) => {
      if (open) {
        suppressHoverOpen(token);
      } else {
        unsuppressHoverOpen(token);
      }
    },
    [token, suppressHoverOpen, unsuppressHoverOpen],
  );

  return { handleMenuOpenChange };
};
